import { defineComponent } from 'vue'
import PointsPage from "@/organizations/_default/points"
import FilterGroupName from '@/organizations/tsumura/default/components/FilterGroupName.vue'

export default defineComponent({
  extends: PointsPage,
  components: {
    FilterGroupName,
  },
  setup(props, context) {
    const page = PointsPage.setup(props, context)
    return {
      ...page,
      FilterGroupName,
    }
  }
})